export default "__VITE_ASSET__759c59f6__"